import i18n from '@shared/config/i18n';

const { t } = i18n;

export const data = [
  {
    id: 'day',
    title: t('RepeatByDays'),
  },
  {
    id: 'week',
    title: t('RepeatByWeeks'),
  },
  {
    id: 'month',
    title: t('RepeatByMonths'),
  },
  {
    id: 'year',
    title: t('RepeatByYears'),
  },
];
